import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import Admission from "./programsComp/Admission";

function DepartmentPage(props) {
  const data = props.data;
  const [programs, setPrograms] = useState(data);
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    props.setActivePage();
    document.title = `PEACI - ${data.degree ?? "Program"}`;

    getDocs(collection(db, "offices")).then((snap) => {
      const match = snap.docs
        .map((d) => d.data())
        // eslint-disable-next-line
        .find((o) => String(o.idOffice) === String(data.idOffice));
      if (match?.logoUrl) setLogoUrl(match.logoUrl);
    });
    // eslint-disable-next-line
  }, []);

  const careerPaths = [
    programs.p1, programs.p2, programs.p3, programs.p4, programs.p5,
    programs.p6, programs.p7, programs.p8, programs.p9, programs.p10,
  ].filter(Boolean);

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Hero band */}
      <div className="relative w-full bg-gradient-to-r from-sky-900 via-sky-800 to-sky-700 overflow-hidden">
        <div className="absolute inset-0 opacity-10"
          style={{ backgroundImage: "radial-gradient(circle at 70% 50%, white 1px, transparent 1px)", backgroundSize: "32px 32px" }}
        />
        {/* Oversized decorative logo — right edge */}
        {logoUrl && (
          <img
            src={logoUrl}
            alt=""
            aria-hidden="true"
            className="absolute right-0 top-1/2 -translate-y-1/2 h-[200%] w-auto object-contain opacity-10 pointer-events-none select-none"
          />
        )}
        <div className="relative max-w-[1200px] mx-auto px-6 md:px-12 py-14 md:py-20 flex flex-col md:flex-row md:items-center gap-8">
          {/* College logo */}
          {logoUrl && (
            <img
              src={logoUrl}
              alt="College logo"
              className="w-24 h-24 md:w-32 md:h-32 object-contain flex-shrink-0"
            />
          )}
          {/* Text stack */}
          <div className="flex flex-col gap-3">
            <span className="inline-block self-start px-4 py-1 rounded-full bg-white/10 border border-white/20 text-sky-200 text-xs font-semibold tracking-widest uppercase">
              Academic Program
            </span>
            <p className="text-sky-300 text-lg md:text-xl font-light capitalize">
              {programs.bachelor}
            </p>
            <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-white drop-shadow-md leading-tight">
              {programs.degree}
            </h1>
          </div>
        </div>
      </div>

      {/* Content + Sidebar */}
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-10 flex flex-col lg:flex-row gap-10 items-start">

        {/* Main content */}
        <div className="flex-1 min-w-0">
          {/* Description card */}
          <div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-8 mb-8">
            <div className="w-12 h-1 bg-sky-600 rounded-full mb-5" />
            <h2 className="text-xl font-bold text-stone-800 mb-4">About this Program</h2>
            <p className="text-stone-600 text-base leading-relaxed">
              {programs.longDesc}
            </p>
          </div>

          {/* Career Paths card */}
          {careerPaths.length > 0 && (
            <div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-8">
              <div className="w-12 h-1 bg-sky-600 rounded-full mb-5" />
              <div className="flex items-center gap-3 mb-6">
                <h2 className="text-xl font-bold text-stone-800">Career Paths</h2>
                <span className="px-2.5 py-0.5 rounded-full bg-sky-600 text-white text-xs font-bold">
                  {careerPaths.length}
                </span>
              </div>
              <div className="divide-y divide-stone-100">
                {careerPaths.map((path, idx) => (
                  <div key={idx} className="flex items-center gap-4 py-3">
                    <span className="w-8 h-8 rounded-full bg-sky-50 border border-sky-200 text-sky-600 text-sm font-bold flex items-center justify-center flex-shrink-0">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <p className="text-stone-700 text-base leading-snug flex-1">{path}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Admission sidebar */}
        <div className="lg:w-80 flex-shrink-0 w-full">
          <Admission />
        </div>
      </div>
    </div>
  );
}

export default DepartmentPage;
